import React from 'react';

import { cn } from 'components/lib/utils';
import Typography from 'components/Typography/Typography';

const AuthenticationLayout = ({
  main,
  footer,
  title,
  className,
  isLogin = false
}: {
  main: React.ReactNode;
  footer?: React.ReactNode;
  title?: string;
  className?: string;
  isLogin?: boolean;
}) => {
  const bgImage = !isLogin
    ? './assets/images/self-serve-sign-up-bg.png'
    : './assets/images/self-serve-login-bg.png';

  return (
    <div
      className={cn(
        'flex h-full min-h-screen lg:w-full lg:h-screen lg:p-4 gap-x-6 flex-col lg:flex-row justify-between',
        className
      )}
    >
      <div
        className={cn(
          'w-full lg:w-1/2 h-full flex flex-col justify-center items-center gap-y-10 lg:gap-y-0'
        )}
      >
        <div
          className={cn(
            'flex lg:mt-16 flex-col gap-y-2',
            isLogin && 'lg:mt-auto'
          )}
        >
          <img
            className="h-auto w-screen object-contain block lg:hidden"
            src="./assets/images/self-serve-mobile-bg.png"
            alt="first-project-modal-bg"
          />
          <img
            className="w-[197px] object-cover mx-auto"
            src="./assets/images/full-logo-black.svg"
            alt="self-serve-bg"
          />
          {title && (
            <Typography className="text-p-xl font-semibold lg:font-normal text-base-sidebarForeground text-center">
              {title}
            </Typography>
          )}
        </div>
        <div
          className={cn(
            'px-4 max-w-[374px] lg:px-0 w-full lg:my-auto flex flex-col items-center',
            isLogin && 'lg:mt-6'
          )}
        >
          {main}
        </div>
        <div className="mb-16">{footer}</div>
      </div>
      <img
        className="lg:block lg:rounded-[10px] lg:w-1/2 hidden h-full object-cover"
        src={bgImage}
        alt="self-serve-bg"
      />
    </div>
  );
};

export default AuthenticationLayout;
